import { render, staticRenderFns } from "./SoniprevPaginatedSearch.vue?vue&type=template&id=38d618ce&"
import script from "./SoniprevPaginatedSearch.vue?vue&type=script&lang=js&"
export * from "./SoniprevPaginatedSearch.vue?vue&type=script&lang=js&"
import style0 from "./SoniprevPaginatedSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports